module.exports = __webpack_public_path__ + "img/Alien_symbol_5.3cfcb710.png";